// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"ce_a bhk_h bhk_kf bhk_wb bhk_ss bhk_vr bhk_su bhk_sl"};